import React, { useState } from "react";
import Dropdown from "./Dropdown";
import "./ItemAvailability.css";

const ItemAvailability = ({
  data,
  onChange,
  onDiscard,
  onNext,
  xpressChef,
  saasUser
}) => {
  const {
    isPreOrder,
    itemForever,
    orderBy,
    menuTypes,
    isAllDaySelected,
    availabilityPlatform
  } = data;

  const AVAILABILITYPLATFORMS = ["Homeal App", "Saas Website", "Both"];
  const AVAILABILITYSELECTIONS = ["Daily Order", "Pre-order only"];

  const [openDropdown, setOpenDropdown] = useState(null);

  const handleSelectItemAvailability = (item) => {
    onChange({
      ...data,
      isPreOrder: item.toUpperCase() === "PRE-ORDER ONLY",
    });
    setOpenDropdown(null); 
  };

  const handleSelectItemForever = () => {
    onChange({ ...data, itemForever: !itemForever });
  };

  const handleOrderBy = (e) => {
    const [hourStr, minutes] = e.target.value.split(":");
    let hours = parseInt(hourStr, 10);
    const suffix = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; 
    const formattedTime = `${String(hours).padStart(2, "0")}:${minutes} ${suffix}`;
    onChange({ ...data, orderBy: formattedTime });
};
  

  const handleMenuTypePress = (menuType, isSelected) => {
    let updatedMenuTypes = [...menuTypes];

    if (menuType.toUpperCase() === "ALL DAY") {
      if (isSelected) {
        updatedMenuTypes = [
          "Breakfast",
          "Lunch",
          "Dinner",
          "Snacks",
          "All Day",
        ];
      } else {
        updatedMenuTypes = [];
      }
    } else {
      if (isSelected) {
        if (!menuTypes.map(type => type.toUpperCase()).includes("ALL DAY")) {
          updatedMenuTypes.push(menuType);
        }
      } else {
        updatedMenuTypes = updatedMenuTypes.filter(
          (type) => type.toUpperCase() !== menuType.toUpperCase()
        );
      }
    }
    onChange({
      ...data,
      menuTypes: updatedMenuTypes,
      isAllDaySelected: updatedMenuTypes
        .map(type => type.toUpperCase())
        .includes("ALL DAY"),
    });
  };

  const handlePlatformAvailability = (item) => {
    onChange({ ...data, availabilityPlatform: item });
    setOpenDropdown(null); 
  };

  const toggleDropdown = (dropdown) => {
    if (openDropdown === dropdown) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(dropdown);
    }
  };

  const to24HourFormat = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") hours = "00";
    if (modifier === "PM") hours = parseInt(hours, 10) + 12;
    return `${String(hours).padStart(2, "0")}:${minutes}`;
  };

  return (
    <div className="item-availability-container">
      <h2 className="availability-text">Availability</h2>
      <hr className="separator" />
      <div className="dropdown-container">
        <label className="dropdown-label">This item is available for</label>
        <Dropdown
          options={AVAILABILITYSELECTIONS}
          onSelect={handleSelectItemAvailability}
          placeholder="Select Availability"
          selectedItems={[isPreOrder ? "Pre-order only" : "Daily Order"]}
          multiSelect={false}
          maxSelect={1}
          isOpen={openDropdown === "isPreOrder"}
          onToggle={() => toggleDropdown("isPreOrder")}
        />
        <div className="checkbox-container">
          <input
            type="checkbox"
            checked={itemForever}
            onChange={handleSelectItemForever}
          />
          <label>Make this item available forever</label>
        </div>
        {!xpressChef ? 
        <div className="form-group">
                <label>Order By - {orderBy}</label>
                <input
                    type="time"
                    className="form-control"
                    value={to24HourFormat(orderBy)}
                    onChange={(e) => handleOrderBy(e)}
                />
          </div> : null}
        <label className="dropdown-label">This item is served during</label>
        <div className="menu-types-container">
          {["Breakfast", "Lunch", "Dinner", "Snacks", "All Day"].map(menuType => (
            <div
              key={menuType}
              className={`menu-type ${menuTypes.includes(menuType) || isAllDaySelected ? 'selected' : ''}`}
              onClick={() => handleMenuTypePress(menuType, !menuTypes.includes(menuType))}
            >
              {menuType}
            </div>
          ))}
        </div>
        {saasUser && (
          <>
            <label className="dropdown-label">This item is Available only</label>
            <Dropdown
              options={AVAILABILITYPLATFORMS}
              onSelect={handlePlatformAvailability}
              placeholder="Select Platform"
              selectedItems={[availabilityPlatform]}
              multiSelect={false}
              maxSelect={1}
              isOpen={openDropdown === "availabilityPlatform"}
              onToggle={() => toggleDropdown("availabilityPlatform")}
            />
          </>
        )}
      </div>
      <div className="button-group">
        <button
          className={`discard-button`}
          onClick={onDiscard}
        >
          Back
        </button>
        <button
          className={`next-button ${!(menuTypes.length > 0) ? 'disabled' : ''}`}
          onClick={onNext}
          disabled={menuTypes.length === 0}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ItemAvailability;
